import { useOutletContext } from "react-router-dom";

import { NV_PATHS } from "@/components/navigator";
import type { MySummary } from "@/services/navigator/my-page-service";

// My Page 틀 · 섹션 공용 (요약 컨텍스트 · 본문 제목)

export const MY_PAGE_BASE = NV_PATHS.myPage;

export interface MyPageContext {
  summary: MySummary;
  refresh: () => void;
  // 회원 탈퇴 확인 팝업 열기 (내 정보의 계정 카드 · 틀의 팝업 상태)
  onWithdraw: () => void;
  // 본문 아래에 화면 폭 전체로 붙는 하단 바 자리 (비교함의 [선택 해제] [비교하기], Figma ver.7 Bottom Bar / 비교하기). 섹션이 portal로 채워요
  barSlot: HTMLElement | null;
}

export function useMyPage() {
  return useOutletContext<MyPageContext>();
}

// Figma ver.6 본문 제목: 500 20/24 + 설명 13/16 #5E626A
export function MyPageHeader({ title, description }: { title: string; description?: string }) {
  return (
    <div className="flex flex-col gap-1">
      <h1 className="text-[20px] font-medium leading-6 text-nv-text-primary">{title}</h1>
      {description && <p className="text-[13px] leading-4 text-nv-text-secondary">{description}</p>}
    </div>
  );
}
